import ApiConfig from "../config/Api.config";
import Request from "../interfaces/Request.interface";
import Response from "../interfaces/Response.interface";
import Login from "../interfaces/Login.interface";

const url = `${ApiConfig.URLBase}/usuarios`

const login = async (login: Login): Promise<Response> => {
    
    const request: Request = {
        url: `${url}/login`,
        metodo: "POST",
        data: { username: login.username, password: login.password }
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;

};


const UsuarioService = {
    login,
};

export default UsuarioService;